import styled, { css } from 'styled-components';

import { Link as ReactRouterLink } from 'components/RouterLink';
import { colors } from 'theme/theme';

const menuItemCss = css`
  display: block;
  margin: 0;
  padding: 10px 12px;
  cursor: pointer;
  color: ${colors.lightContentGrey};
  text-decoration: none;
  font-size: inherit;
  font-weight: normal;
  white-space: unset;

  &:hover {
    background-color: ${colors.inputGrey};
    text-decoration: none;
    color: ${colors.mediumContentGrey};
  }

  .truncate {
    overflow: hidden;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &:disabled {
    opacity: 0.25;
  }
`;

export const DropdownListMenuItem = styled.a<{
  $disabled?: boolean;
  $logoutLink?: boolean;
}>`
  ${menuItemCss};

  ${(props) =>
    props.$logoutLink &&
    css`
      color: ${colors.decorativePoppy};

      &:hover {
        color: ${colors.decorativePoppy};
        background-color: ${colors.lightRed};
      }
    `}
`;

export const DropdownListMenuItemRouter = styled(ReactRouterLink)`
  ${menuItemCss};
`;
